export const secondToMinute = (seconds) => ({
  minutes: Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0'),
  seconds: (seconds % 60).toString().padStart(2, '0'),
});

export default secondToMinute;
